import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUIStore } from '../stores/uiStore';

const DISMISS_KEY = 'melodiza:migration-banner-dismissed-at';
const TTL_DAYS = 14;
const TTL_MS = TTL_DAYS * 24 * 60 * 60 * 1000;

export function MigrationBanner() {
  const show = useUIStore(s => s.showMigrationBanner);
  const setShow = useUIStore(s => s.setShowMigrationBanner);
  const navigate = useNavigate();

  // Auto-hide if previously dismissed within 14 days
  useEffect(() => {
    try {
      const dismissedAt = localStorage.getItem(DISMISS_KEY);
      if (dismissedAt && (Date.now() - parseInt(dismissedAt, 10)) < TTL_MS) {
        setShow(false);
      }
    } catch {
      // ignore localStorage errors
    }
  }, [setShow]);

  if (!show) return null;

  const handleDismiss = () => {
    try {
      localStorage.setItem(DISMISS_KEY, String(Date.now()));
    } catch {
      // ignore
    }
    setShow(false);
  };

  const handleLearnMore = () => {
    navigate('/library');
    handleDismiss();
  };

  return (
    <div className="migration-banner" role="status" aria-live="polite">
      <p>
        Nous avons réorganisé votre bibliothèque.
        Découvrez les nouvelles playlists Melodiza.
      </p>
      <button onClick={handleLearnMore} aria-label="En savoir plus sur la réorganisation">
        En savoir plus
      </button>
      <button onClick={handleDismiss} aria-label="Fermer cette notification">
        Compris
      </button>
    </div>
  );
}
